import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { useUsersRetrieve } from "@/api/generated/backendAPI";
import UserImage from "@/components/ui/UserImage";

export const Route = createFileRoute("/_layout/_auth/profile/$userId")({
  component: UserProfile,

});

function UserProfile() {
  const {userId} = Route.useParams()
  const { data: user } = useUsersRetrieve(userId);
  const [displayName, setDisplayName] = useState<string>("");

  useEffect(() => {
    if(user){
      const initialDisplayName = user.displayName
        ? user.displayName
        : user.name;
      setDisplayName(initialDisplayName)
    }
  }, [user])


  return (
    <>
      <h1>プロフィール</h1>
      <div className="flex flex-col items-start justify-start gap-4">
        <div className="w-full bg-white p-4 rounded-md shadow-xs-slate-200">
          <div>
            <h2 className="font-bold">公開情報</h2>
          </div>
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-16">
              <div className="relative size-28">
{
                      (user && <UserImage userId={user.id} noImageType="noimage" size={28} />)
                }
              </div>
              <div>
                <p className="text-sm text-slate-600">表示名</p>
                      <p className=
                          "tracking-wide py-2 pr-2 text-lg"
                      >
                        {displayName}
                      </p>
              </div>
            </div>
          </div>
        </div>
        {/* start 組織情報 ※編集なし */}
        <div className="w-full bg-white p-4 rounded-md shadow-xs-slate-200">
          <div className="flex items-center justify-between">
            <h2 className="font-bold">組織情報</h2>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-[repeat(2,minmax(max-content,360px))] gap-4 mt-4">
            {
              user?.organizations.map((data, index) => {
                const multiOrganizationSuffix = user.organizations.length > 1 ? " " + (index + 1).toString() : ""
                return (
                  <>
                  <div className="w-max" key={data.organizationId + index.toString()}>
                  <p className="text-sm text-slate-600">所属組織{multiOrganizationSuffix}</p>
                  {
                    <p
                      className={"tracking-wide py-2 pr-2 text-lg"}
                    >
                      {data.organizationName}
                    </p>
                  }
                </div>
                <div className="w-max" key={data.departmentId + index.toString()}>
                  <p className="text-sm text-slate-600">部署名{multiOrganizationSuffix}</p>
                  {
                    <p
                      className={"tracking-wide py-2 pr-2 text-lg"}
                    >
                      {data.departmentName}
                    </p>
                  }
                </div>
                </>
                )
              })
            }
          </div>
        </div>
        {/* end 組織情報 */}
        {/* start 獲得メダル */}
        <div className="w-full bg-white p-4 rounded-md shadow-xs-slate-200">
          <div className="flex items-center justify-between">
            <h2 className="font-bold">獲得メダル</h2>
          </div>
        </div>
        {/* end 基本情報 */}
        {/* start コンペティション情報 */}
        <div className="w-full bg-white p-4 rounded-md shadow-xs-slate-200">
          <div className="flex items-center justify-between">
            <h2 className="font-bold">参加コンペティション</h2>
          </div>
        </div>
        {/* end 基本情報 */}
      </div>
    </>
  );
}
